<template>
    <div class="left-wrapper">
        <div class="title">地块列表</div>
        <div class="search-box">
            <el-input
                placeholder="请输入地块名称"
                suffix-icon="el-icon-search"
                v-model="searchForm.name"
                clearable
                @input="getLandList"
            >
            </el-input>
        </div>
        <div class="select">
            <div>
                <el-select v-model="searchForm.type" placeholder="土地类型" clearable @change="getLandList">
                    <el-option
                        v-for="item in mixin_LandTypeDicList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                    >
                    </el-option>
                </el-select>
            </div>
            <div>
                <el-select
                    v-model="searchForm.landStatus"
                    placeholder="土地状态"
                    clearable
                    @change="getLandList"
                >
                    <el-option
                        v-for="item in mixin_LandStatusDicList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                    >
                    </el-option>
                </el-select>
            </div>
        </div>
        <div class="icons">
            <img src="../imgs/menu-line@2x.png" alt="" class="icon-list" />
            <img src="../imgs/竖线.png" alt="" class="line" />
            <img src="../imgs/movie-line@2x.png" alt="" class="icon-movie" />
        </div>
        <div class="plot-list">
            <YScroll style="height: 100%">
                <template>
                    <LBTree :treeData="treeData" :isParent="(data) => data.children">
                        <template v-slot:parent="ctx">
                            <div class="c-mainpage-left__tree-item" @click="expandChildren(ctx.row)">
                                <div class="c-mainpage-left__tree-item-name">
                                    {{ ctx.row.name + '('
                                    }}<span class="num">{{ ' ' + ctx.row.children.length + ' ' }}</span
                                    >)
                                </div>
                                <div
                                    class="
                                        c-mainpage-left__tree-item-icon c-mainpage-left__tree-item-icon--light
                                    "
                                >
                                    <i
                                        :style="{
                                            transform: ctx.row.showChildren
                                                ? 'rotate(180deg)'
                                                : 'rotate(0deg)',
                                        }"
                                        class="el-icon-arrow-down"
                                    ></i>
                                </div>
                            </div>
                        </template>
                        <template v-slot:children="ctx">
                            <div
                                @click="toDetailView(ctx.row, '1')"
                                class="c-mainpage-left__tree-item is-sub"
                                :class="[`c-mainpage-left__tree-item--color${ctx.row.landStatus}`]"
                            >
                                <div class="c-mainpage-left__tree-item-name tree_name" :title="ctx.row.name">
                                    <img :src="require('../imgs/item.png')" alt="" />
                                    {{ ctx.row.name }}
                                </div>
                                <div class="c-mainpage-left__tree-item-icon">
                                    {{ mixin_LandStatusDic[ctx.row.landStatus] }}
                                    <i class="el-icon-arrow-right"></i>
                                </div>
                            </div>
                        </template>
                    </LBTree>
                </template>
            </YScroll>
        </div>
    </div>
</template>

<script>
import { YScroll } from '@CommonComponent';
import LBTree from '../../mainPage/components/LBTree.vue';
import * as Api from './Api';
import DicMixin from '../mixins/DicMixin';

export default {
    mixins: [DicMixin],
    components: {
        YScroll,
        LBTree,
    },
    props: {
        onLandList: {
            // 获取到土地数据时会调用该函数
            type: Function,
            default: null,
        },
    },
    data() {
        return {
            monitoring: '',
            searchForm: {
                name: '',
            },
            defaultProps: {
                children: 'children',
                label: 'label',
            },
            organList: [], // 机构列表
            landList: [], // 地块列表
        };
    },
    computed: {
        treeData() {
            let res = [];
            let organList = this.organList;
            let landList = this.landList;
            organList.forEach((item, index) => {
                let children = landList.filter((landItem) => landItem.organId === item.id);
                let obj = item;
                obj.children = children;
                obj.showChildren = true;
                if (index > 0) {
                    obj.showChildren = false;
                }
                res.push(obj);
            });

            return res;
        },
    },
    methods: {
        expandChildren(row) {
            let showChildren = row.showChildren;
            this.$set(row, 'showChildren', !showChildren);
        },
        // 点击树形children
        toDetailView(data) {
            this.$emit('treeChildreClick', data);
        },
        // 获取区域机构列表
        getOrganList() {
            let list = [];
            Api.fetchOrganList()
                .run()
                .then((res) => {
                    list = res || [];
                    list.forEach((item) => {
                        // 必须在这里加showChldren属性，否则树形展开不了，因为computed 里面treeData无法监测到showChildren变化
                        item.showChildren = true;
                    });
                    this.organList = list;
                });
        },
        // 获取地块列表
        getLandList() {
            let list = [];
            let params = this.searchForm;
            Api.fetchLandList(params)
                .run()
                .then((res) => {
                    list = res || [];
                    this.landList = list;
                    if (typeof this.onLandList === 'function') {
                        this.onLandList(list);
                    }
                });
        },
        // 获取数据字典
        getDic() {
            this.mixinGetLandTypeDic();
            this.mixinGeLandStatusDic();
        },
    },
    mounted() {
        this.getDic();
        this.getOrganList();
        this.getLandList();
    },
};
</script>

<style lang="scss" scoped>
@import '~@Theme/config.scss';
@import '~@Theme/mixins/index.scss';

.left-wrapper {
    .title {
        padding-top: 11px;
        text-align: center;
        font-size: 18px;
        height: 37px;
        background-image: url(../imgs/titlebg01.png);
    }

    .search-box {
        padding: 0 16px;
        padding-top: 11px;
    }

    ::v-deep .el-input__inner {
        border-color: #1a47a4;
        background-color: transparent;
    }

    .select {
        margin-top: 11px;
        display: flex;
        justify-content: space-between;
        padding: 0 16px;
    }

    ::v-deep .el-select {
        width: 135px;
        border-color: #1a47a4;
        background-color: transparent;
    }
    ::v-deep .el-input__inner {
        color: #fff !important;
    }

    .icons {
        margin-top: 11px;
        text-align: center;

        .icon-list {
            width: 18px;
            height: 18px;
            cursor: pointer;
        }

        .line {
            width: 18px;
            height: 18px;
        }

        .icon-movie {
            width: 18px;
            height: 18px;
            cursor: pointer;
        }
    }

    .plot-list {
        margin-top: 11px;
        padding: 0 16px;
        height: 630px;
    }

    @include b(mainpage-left, c) {
        @include e(tree-item) {
            display: flex;
            justify-content: space-between;
            height: 30px;
            line-height: 30px;
            color: white;
            cursor: pointer;
            margin-bottom: 8px;

            @include when(sub) {
                padding-left: 5px;
            }

            @include m(color1) {
                background-image: linear-gradient(
                    90deg,
                    hsla(160, 65%, 61%, 60%) 0%,
                    hsla(160, 65%, 61%, 30%) 30%,
                    hsla(160, 65%, 61%, 30%) 70%,
                    hsla(160, 65%, 61%, 60%)
                );
                border: 1px solid hsla(160, 65%, 61%, 100%);
                border-left-width: 5px;
                vertical-align: middle;
            }

            @include m(color2) {
                background-image: linear-gradient(
                    90deg,
                    hsla(209, 100%, 51%, 60%) 0%,
                    hsla(209, 100%, 51%, 30%) 30%,
                    hsla(209, 100%, 51%, 30%) 70%,
                    hsla(209, 100%, 51%, 60%)
                );
                border: 1px solid hsl(209, 100%, 51%);
                border-left-width: 5px;
            }

            @include m(colorerror) {
                background-image: linear-gradient(
                    90deg,
                    hsla(339, 73%, 47%, 60%) 0%,
                    hsla(339, 73%, 47%, 30%) 30%,
                    hsla(339, 73%, 47%, 40%) 70%,
                    hsla(339, 73%, 47%, 60%)
                );
                border: 1px solid hsl(339, 73%, 47%);
                border-left-width: 5px;
            }

            @include m(colordisable) {
                background-image: linear-gradient(
                    90deg,
                    hsla(218, 31%, 48%, 60%) 0%,
                    hsla(218, 31%, 48%, 30%) 30%,
                    hsla(218, 31%, 48%, 30%) 70%,
                    hsla(218, 31%, 48%, 60%)
                );
                border: 1px solid hsl(218, 31%, 48%);
                border-left-width: 5px;
            }
            @include m(color3) {
                background-image: linear-gradient(
                    90deg,
                    hsla(218, 31%, 48%, 60%) 0%,
                    hsla(218, 31%, 48%, 30%) 30%,
                    hsla(218, 31%, 48%, 30%) 70%,
                    hsla(218, 31%, 48%, 60%)
                );
                border: 1px solid hsl(218, 31%, 48%);
                border-left-width: 5px;
            }

            @include e(tree-item-name) {
                vertical-align: middle;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;

                // width: 100px;
                .num {
                    color: hsl(184, 97%, 64%);
                }

                img {
                    vertical-align: middle;
                }
            }

            .tree_name {
                width: 164px;
            }

            @include e(tree-item-icon) {
                @include m(light) {
                    color: hsl(184, 98%, 64%);
                }
            }
        }
    }

    // .el-tree {
    //     background-color: transparent;
    //     color: #fff;
    // }

    // ::v-deep .el-tree-node__label {
    //     font-size: 16px;
    // }

    // ::v-deep .el-tree-node__expand-icon {
    //     position: absolute;
    //     right: 2%;
    // }

    // ::v-deep .el-tree-node__expand-icon.expanded {
    //     -webkit-transform: rotate(180deg);
    //     transform: rotate(180deg);
    // }

    // ::v-deep .el-scrollbar__wrap {
    //     height: 690px;
    // }
}
</style>
